import { request, Logger } from '@nextgen-web-framework/core';
import logObject from '../../../../logObject';
import { BonusData } from '../../models';
import { getPVBVReqObj } from '../../config';
import { GetPvBvPropType, CustomRequestOptions } from '../../../types/amshopTypes';

export const bonusApi = {
  async getPVBV({ period, aboNumber }: GetPvBvPropType, options?: CustomRequestOptions): Promise<BonusData> {
    const loggerInstance = Logger.getInstance(logObject('bonusApi.getPVBV'));
    try {
      const req = getPVBVReqObj();
      req.params = {
        period,
        ...(aboNumber && { aboNumber }),
      };

      if (options?.headers) {
        req.headers = options?.headers;
      }
      if (options?.baseURL) {
        req.url = `${options.baseURL}${req.url}`;
      }

      const response: BonusData = await request(req);
      return Promise.resolve(response);
    } catch (error) {
      loggerInstance.error('bonusApi.getPVBV', error);
      throw error;
    }
  },
};

export default bonusApi;
